import { VersionNumber } from '@tableau/api-internal-contract-js';
import { AddInInstancePresModel } from '../../gen-src/preslayer/PresModels';
import { ApiContext } from '../ApiContext';
import { ApiDispatcher } from '../common-bootstrap/ApiDispatcher';
import { EmbeddingApiDispatcher } from '../embedding-bootstrap/EmbeddingApiDispatcher';
import { PresLayerOptionalCompatibility } from '../mappings/PresLayerOptionalCompatibility';
import { EmbeddingServerContext } from './EmbeddingServerContext';
import { ExtensionServerContext } from './ExtensionServerContext';

function handleVisibilityChange(): void {
  const apiContext = ApiContext.getInstance();
  if (document.visibilityState === 'hidden') {
    apiContext.setIsVisible(false);
  } else {
    apiContext.setIsVisible(true);
  }
}

/**
 * Server bootstrap. This code creates the ApiDispatcher.
 * @see comments in JsApiPlatform.ts.
 */

export function createApiDispatcher(
  extensionInstancePresModel: AddInInstancePresModel,
  serverContext: ExtensionServerContext,
): ApiDispatcher {
  // setup api context;
  const apiContext = ApiContext.getInstance();
  apiContext.setIsServer(true);
  apiContext.setIsVisible(document.visibilityState === 'visible');

  document.addEventListener('visibilitychange', handleVisibilityChange, false);

  apiContext.setIsAuthoring(serverContext.isAuthoring);
  apiContext.setIsPublic(serverContext.isPublic);
  apiContext.setIsSaas(serverContext.isSaas);
  apiContext.setIsPlatformOfficialRelease(serverContext.isOfficialRelease);
  apiContext.setIsFirstClass(
    PresLayerOptionalCompatibility.optionalToRequiredUnsafeCast(extensionInstancePresModel.addInRegistrationPresModel)
      .extensionIsFirstclass,
  );

  return new ApiDispatcher(extensionInstancePresModel);
}

export function createEmbeddingApiDispatcher(internalVersion: string, serverContext: EmbeddingServerContext): EmbeddingApiDispatcher {
  const versionComps = internalVersion.split('.');
  const version: VersionNumber = {
    major: Number.parseInt(versionComps[0], 10),
    minor: Number.parseInt(versionComps[1], 10),
    fix: Number.parseInt(versionComps[2], 10),
  };

  // setup api context;
  const apiContext = ApiContext.getInstance();
  apiContext.setIsServer(true);
  apiContext.setIsAuthoring(serverContext.isAuthoring);
  apiContext.setExternalApiVersion(serverContext.externalApiVersion);

  return new EmbeddingApiDispatcher(version);
}
